import { ReactElement } from 'react';
import Divider from '../../../Divider';
import IconButton from '../../../IconButton';
import Typography from '../../../Typography';
import { CloseIcon } from '../../../../icons';
import { B1, S1 } from '../../../../theme';
import Grid, { IGridProps } from '../../../Grid';
import { mergeSX } from '../../../../services/helpers';

interface IBuildSXParams {
  background?: string
}

interface IPopperTitleProps extends IGridProps, IBuildSXParams {
  children: string | ReactElement;
  showDivider?: boolean;
  onClose?: () => void;
}

const buildSX = ({ background }: IBuildSXParams) => ({
  background,
});

const ICON_BUTTON_SX = { p: 0 };

const PopperTitle = (props: IPopperTitleProps) => {
  const {
    children,
    showDivider = true,
    onClose,
    sx,
    background = S1,
    color,
    ...rest
  } = props;

  return (
    <>
      <Grid
        container
        alignItems="center"
        p={2}
        justifyContent="space-between"
        sx={mergeSX(buildSX({ background }), sx)}
        {...rest}
      >
        <Typography variant="h6" component="span" color={color}>{children}</Typography>
        {onClose && (
          <IconButton onClick={onClose} sx={ICON_BUTTON_SX}>
            <CloseIcon color={B1} />
          </IconButton>
        )}
      </Grid>
      {showDivider && <Divider />}
    </>
  );
};

export default PopperTitle;
